import React, { Fragment, useEffect, useState } from 'react';
import {
    Card,
    CardContent,
    CardHeader,
    Divider,
    makeStyles,
} from '@material-ui/core';
import { ISendWhatsApp } from './types';
import { WhatsAppButton } from './WhatsAppButton';
import { ConversationLink } from './ConversationLink';
import { TAreas } from 'src/constants/lead/leadTypes';
import { getTemplateArea } from '../utils/getTemplateArea';
import { getConversationApi } from '../utils/getConversationApi';
import { ModalTemplates } from 'src/modules/conversations/components/modalTemplates';
import { TCurrentTemplate } from 'src/modules/conversations/components/modalTemplates/types';
import { CURRENT_TEMPLATE_DEFAULT } from 'src/modules/conversations/constants/threads';
import useLead from 'src/hooks/useLead';
import {
    completeAssistantAction,
    failAssistantAction,
    updateAssistantAction,
} from 'src/contexts/assistant/actionLifecycle';

const useStyles = makeStyles(() => ({
    root: {},
}));

export const SendWhatsApp = ({
    lead,
    openFromAssistant,
    assistantRequestKey,
    assistantTemplateCategory,
    assistantTemplateId,
    ...props
}: ISendWhatsApp) => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [currentTemplate, setCurrentTemplate] = useState<TCurrentTemplate>(
        CURRENT_TEMPLATE_DEFAULT
    );
    const area: TAreas = getTemplateArea(lead);
    const handleOpen = () => setOpen(true);
    const { sendTemplateV2, loading } = useLead();
    const handleSendTemplate = async (...args: any[]) => {
        if (assistantRequestKey)
            updateAssistantAction(assistantRequestKey, { status: 'executing' });
        const successful = await sendTemplateV2(...args);
        if (assistantRequestKey)
            successful
                ? completeAssistantAction(assistantRequestKey)
                : failAssistantAction(assistantRequestKey, 'send_failed');
        return successful;
    };

    useEffect(() => {
        if (openFromAssistant && lead?._id) {
            setOpen(true);
            updateAssistantAction(assistantRequestKey, {
                status: 'ready_to_confirm',
            });
        }
    }, [openFromAssistant, assistantRequestKey, lead?._id]);

    return (
        <Fragment>
            <ModalTemplates
                open={open}
                setOpen={setOpen}
                lead={lead}
                currentTemplate={currentTemplate}
                setCurrentTemplate={setCurrentTemplate}
                contextType="lead"
                maxWidth="lg"
                handleSendTemplate={handleSendTemplate}
                loading={loading}
                contextKey={assistantRequestKey}
                preferredCategory={assistantTemplateCategory}
                preferredTemplateId={assistantTemplateId}
                selectFirstTemplate={Boolean(openFromAssistant)}
            />
            <Card className={classes.root} {...props}>
                <CardHeader title="WhatsApp" />
                <Divider />
                <CardContent>
                    <WhatsAppButton onClick={handleOpen} />
                    {lead.conversation && (
                        <ConversationLink
                            conversation={lead.conversation._id}
                            area={area}
                            api={getConversationApi(lead)}
                        />
                    )}
                </CardContent>
            </Card>
        </Fragment>
    );
};
